<template>
    <div id="app">
        <router-view ref="container"/>
    </div>
</template>

<script>
    import wx from "weixin-js-sdk";
    export default {
        name: "App",
        data: () => ({

        }),
        mounted(){

        },
        created() {
            this.initWechatJs()
        },
        methods: {
            initWechatJs(){
                let url = encodeURIComponent(location.href.split('#')[0])
                this.fetchData('/wechat/jssdk',{url:url},(res)=>{
                    if(res.code){
                        wx.config(res.data);
                        wx.ready(()=>{
                            wx.hideMenuItems({
                                menuList: [
                                    "menuItem:share:appMessage",
                                    "menuItem:share:timeline",
                                    "menuItem:share:qq",
                                    "menuItem:share:weiboApp",
                                    "menuItem:share:facebook",
                                    "menuItem:share:QZone",
                                    "menuItem:copyUrl",
                                    "menuItem:originPage",
                                    "menuItem:openWithQQBrowser",
                                    "menuItem:openWithSafari",
                                    "menuItem:readMode"
                                ]
                            });
                        })
                    }
                })
            },
        }
    };

    (function (win, doc) {
        if (!win.addEventListener) return
        let html = document.documentElement
        function setFont() {
            let cliWidth = document.body.clientWidth
            html.setAttribute('style', 'font-size: ' + 100 * (cliWidth / 750) + 'px');
        }
        win.addEventListener('resize', setFont, false);
        doc.addEventListener('DOMContentLoaded', setFont, false)
    })(window, document)
</script>


<style>
    body, html {
        padding: 0;
        margin: 0;
    }

    #app {
        font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        padding: 0;
        margin: 0;
        background: #f9f9f9;
        color: #2c3e50;
    }

    .page-header {
        height: 2.5rem;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        background: -webkit-gradient(linear, left top, left bottom, from(#3c6bff), to(#75b2f9));
        background: linear-gradient(#3c6bff, #75b2f9);
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        -webkit-box-shadow: 0 0 0.6rem 0.6rem #75b2f9;
        box-shadow: 0 0 0.6rem 0.6rem #75b2f9;
    }

    .page-header img {
        margin: 0 .2rem 0 .5rem;
        background: #fff;
        width: 1rem;
        height: 1rem;
        padding: .1rem;
        border-radius: 2rem;
        border: .05rem solid #75b2f9;
    }

    .page-header .page-header-title {
        color: #fff;
        font-weight: 700;
        text-align: left;
        padding-left: .2rem;
    }

    .page-header .page-header-title .site-title {
        padding: 0;
        margin: 0;
        font-size: .5rem;
        line-height: .5rem;
    }

    .page-header .page-header-title .site-desc {
        margin: .1rem 0;
        padding: 0;
        font-size: .3rem;
    }

    .home-nav {
        width: 6.74rem;
        margin: auto;
        padding-top: .1rem;
        padding-bottom: .1rem;
        background: #fff;
        border-radius: .1rem;
        box-shadow: 0 0 0.02rem #dedede;
    }

    .home-nav img {
        margin: 0;
        width: .8rem;
        height: .8rem;
    }

    .home-nav p {
        margin-top: -.1rem;
        font-size: .22rem;
        color: #555;
    }

    .page-footer {
        bottom: .3rem;
        font-size: .16rem;
        color: #555;
        text-align: center;
        width: 7.5rem;
    }

    .page-footer a {
        color: #666;
        text-decoration: #3a8ee6;
    }

    .warm-tips {
        font-size: .25rem;
        margin: 0 .3rem;
        padding: 0 .3rem;
    }

    .warm-tips h5 {
        text-align: left;
        margin: .2rem 0;
        padding-left: .1rem;
        font-size: .3rem;
        border-left: .2rem solid #75b2f9;
    }

    .warm-tips ol {
        text-align: left;
        padding: 0;
        font-size: .24rem;
    }

    .warm-tips ol li {
        list-style: disc;
        line-height: .4rem;
    }

</style>



// WEBPACK FOOTER //
// src/App.vue